import { useEffect, useState } from 'react';
import { checkCompleteness, type Nudge } from './api';

const DEBOUNCE_MS = 800;

/**
 * Completeness nudges that follow the document as the doctor writes.
 * Deterministic and advisory (backend/utils/docCompleteness.js); a failed
 * check keeps the last nudges rather than showing an error, since nothing here
 * ever blocks approval.
 */
export function useCompleteness(visitCode: string | undefined, content: string, initial: Nudge[] = []): Nudge[] {
  const [nudges, setNudges] = useState<Nudge[]>(initial);

  useEffect(() => {
    if (!visitCode) return;
    let cancelled = false;
    const handle = setTimeout(() => {
      checkCompleteness(visitCode, content)
        .then((result) => { if (!cancelled) setNudges(result.nudges); })
        .catch(() => { /* advisory — keep the previous nudges */ });
    }, DEBOUNCE_MS);
    return () => { cancelled = true; clearTimeout(handle); };
  }, [visitCode, content]);

  return nudges;
}
